import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { DigestsNotificationsPage } from './ui/index.tsx';

export default function DigestsPersonalSettingsApp() {
	return (
		<JSErrorBoundary
			id="personalSettingsDigestsNotifications"
			packageName="jiraPersonalSettingsDigestsNotifications"
			teamName="frontier"
		>
			<ContextualAnalyticsData
				sourceName="personalSettingsDigestsNotifications"
				sourceType={SCREEN}
			>
				<DigestsNotificationsPage />
			</ContextualAnalyticsData>
		</JSErrorBoundary>
	);
}
